<template>
  <div class="orderPayment">
    <div class="all-center-box">
      <div class="w-1500">
        <div class="address-box w-100">
          <router-link to="/">首页</router-link> /
          <router-link to="/orderPayment">订单完成</router-link>
        </div>
        <div class="order-payment-main">
          <div class="order-infos">
            <div class="box">
              <div class="txt">
                订单已生成（订单号：<em>{{ orderInfo.order.serialNumber }}</em
                >）
              </div>
              <div class="txt">
                订单生成时间：{{ orderInfo.order.whenCreated }}&emsp;订购人：{{
                  orderInfo.contacter
                }}
              </div>
              <div class="desc">
                <div class="price">
                  应付金额：<em>¥{{ orderInfo.order.totalPrice }}</em>
                </div>
                <div class="txt">
                  根据支付时间的不同，发货日可能会有变化。请尽快支付，并在支付完成订单状态变为【已处理】时再次确认最终发货日。<br />
                  若您选择了闪达服务，为确保及时送达，<em
                    >建议您在30分钟内完成付款。</em
                  ><br />
                  过期后此单将自动取消，请在此日期之前支付。<br />
                  <!-- 配送公司：<span>暂无</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="page-center-box w-100">
          <div class="ksbj-box w-100">
            <div class="box-info1 w-100">— 支付确认 —</div>
            <div class="box-info2 w-100 between-center">
              <el-form class="pull-left" @submit.native.prevent="handleSubmit">
                <!-- <div class="box1 w-100">
                  <span><i>*</i> 汇款人：</span>
                  <input
                    v-model="orderForm.name"
                    type="text"
                    class="text"
                    name=""
                    id=""
                    value=""
                    placeholder="请输入汇款人"
                  />
                </div>
                <div class="box1 w-100">
                  <span><i>*</i> 汇款人联系方式：</span>
                  <input
                    v-model="orderForm.phone"
                    type="text"
                    class="text"
                    name=""
                    id=""
                    value=""
                    placeholder="请输入汇款人联系方式"
                  />
                </div>
                <div class="box1 w-100">
                  <span><i>*</i> 汇款行：</span>
                  <input
                    v-model="orderForm.bank"
                    type="text"
                    class="text"
                    name=""
                    id=""
                    value=""
                    placeholder="请输入汇款行"
                  />
                </div> -->
                <div class="box1 w-100">
                  <span><i>*</i> 汇款金额：</span>
                  <input
                    v-model="orderForm.money"
                    type="text"
                    class="text"
                    name=""
                    id=""
                    value=""
                    placeholder="请输入汇款金额"
                  />
                </div>
                <div class="box1 w-100">
                  <span><i>*</i> 汇款凭证：</span>
                  <el-upload
                    class="upload-demo"
                    :action="actionUrl"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-success="handleSuccess"
                    :before-remove="beforeRemove"
                    :multiple="filelimit > 1"
                    :limit="filelimit"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                    :list-type="listType"
                    :show-file-list="false"
                    v-if="imageUrl === ''"
                  >
                    <i
                      v-if="listType === 'picture-card'"
                      class="el-icon-plus"
                    />
                    <el-button
                      v-else
                      :disabled="disabled"
                      size="small"
                      type="primary"
                      >点击上传</el-button
                    >
                  </el-upload>
                  <li
                    @mouseenter="isDeleteImage = true"
                    @mouseleave="isDeleteImage = false"
                    v-else
                    class="image-delete"
                  >
                    <!-- <img class="image" :src="imageUrl" style="width: 10rem" /> -->
                    <el-image
                      class="image"
                      style="width: 10rem"
                      :src="imageUrl"
                      :preview-src-list="[imageUrl]"
                    >
                    </el-image>
                    <span
                      v-show="isDeleteImage"
                      class="item-delete"
                      @click="handleRemoveFileDetail"
                    >
                      <i class="el-icon-delete" />
                    </span>
                    <span class="overlay"></span>
                  </li>
                </div>
                <button class="btns">提交</button>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setOfflinePay } from '../../common/http';

export default {
  props: {

  },
  data () {
    return {
      orderInfo: {},
      orderForm: {
        name: '',
        phone: '',
        money: '',
        orderUid: '',
        bank: '',
        image: '3954',
      },
      filelimit: 1,
      // imageUrl: "http://hlxweb.tjsjnet.com/accessory/default_/category/20240805/64166ec4cf05484e9ebe08a0200934ff.png",
      imageUrl: "",
      fileList: [],
      listType: "picture-card",
      isDeleteImage: false
    };
  },
  computed: {
    actionUrl () {
      const baseUrl = process.env.NODE_ENV === "development" ? "dev-api" : process.env.VUE_APP_BASE_URL
      return baseUrl + '/upload/nologin/uploadAccessory.htm'
    }
  },
  created () {
    this.orderInfo = this.$route.query.data;
    this.orderForm.orderUid = this.orderInfo.order.serialNumber;
  },
  mounted () {

  },
  watch: {

  },
  methods: {
    handleSubmit (event) {
      if (this.orderForm.money === '') {
        this.$message.error("请填写汇款金额");
        return
      }
      if (this.orderForm.image === '') {
        this.$message.error("请上传证明");
        return
      }
      if (this.orderForm.money !== this.orderInfo.order.totalPrice.toString()) {
        this.$message.error("汇款金额与应付金额不符合");
        return
      }
      setOfflinePay(this.orderForm).then(res => {
        if (res.result) {
          this.$message.success('支付成功');
          this.$router.push("/meOrder");
        }
      })
    },
    handleRemove (file, fileList) {
      console.log(file, fileList);
    },
    handlePreview (file) {
      console.log(file);
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件上传成功的钩子
    handleSuccess (res, file, fileList) {
      if (res.code === 600 && res.result === true) {
        this.$message.success('上传成功')
        this.orderForm.image = res.data[0].acyId;
        this.imageUrl = res.data[0].url;
      }
    },
    handleRemoveFileDetail () {
      this.fileList = [];
      this.imageUrl = ''
    },
  },
  components: {

  },
};
</script>

<style scoped>
.page-center-box {
  padding-bottom: 1.5rem;
}

.page-center-box .page-left {
  width: 16%;
  background: #fff;
  min-height: 33.75rem;
  float: left;
}

.page-center-box .page-left .box-info1 {
  line-height: 3.75rem;
  background: #ffb300;
  padding: 0 1rem;
  font-size: 1.125rem;
  color: #fff;
}

.page-center-box .page-left .box-info2 span {
  width: 100%;
  float: left;
  line-height: 3.75rem;
  position: relative;
  padding-left: 1.875rem;
  font-size: 0.875rem;
  color: #333;
  cursor: pointer;
}

.page-center-box .page-left .box-info2 span::after {
  content: '';
  width: 0.25rem;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: #004194;
  display: none;
}

.page-center-box .page-left .box-info2 span:hover {
  background: #e0eeff;
}

.page-center-box .page-left .box-info2 span.active {
  background: #e0eeff;
}

.page-center-box .page-left .box-info2 span.active::after {
  display: block;
}

.page-center-box .page-right {
  width: 83%;
  background: #fff;
  padding: 1.25rem;
  float: right;
}

.image-delete {
  position: relative;
  cursor: pointer;
}
.item-delete {
  position: absolute;
  color: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.image {
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 蒙版颜色和透明度 */
  opacity: 0; /* 初始时透明 */
  transition: opacity 0.3s ease;
  pointer-events: none; /* 防止遮挡鼠标事件 */
}

/* 鼠标悬停时的效果 */
.image-delete:hover .overlay {
  opacity: 0.5; /* 鼠标进入时显示蒙版 */
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/offLinePay.vue